<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 ref="topPaieskaForm" class="mb-2">{{ paieskaTitle }}</h3>
    <div class="dataContainer">
      <form @keydown.enter.prevent="submit()">
        <v-row>
          <v-col cols="12" v-if="showConfirmKlaida">
            <v-alert dense outlined type="error">
              <span v-html="confirmKlaida"></span>
            </v-alert>
          </v-col>
          <template v-if="!isKodas || true">
            <v-col cols="12" md="12">
              <v-row
                no-gutters
                v-for="(paslaugaItem, paslaugaIndex) in paslaugaList"
                :key="paslaugaItem.value"
                align="center"
              >
                <v-col cols="12" sm="10">
                  <template v-if="!isKodas">
                    <el-checkbox
                      :check-value="paslaugaItem.value"
                      :required="paslaugaItem.required"
                      :readonly="paslaugaItem.disabled"
                      :label-grey="paslaugaItem.disabled"
                      :label="paslaugaItem.text"
                      :tooltip="paslaugaItem.tooltip"
                      silent
                      v-model="selectedPaslauga"
                    />
                  </template>
                  <template v-if="isKodas">
                    <div class="paslauga-kodas">
                      {{ paslaugaItem.text }}
                    </div>
                  </template>
                </v-col>
                <v-col cols="12" sm="2" class="text-right" v-if="showKaina">
                  <div class="v-input--checkbox">
                    <div
                      :class="
                        `v-label theme--light ${
                          paslaugaItem.disabled ? 'v-label--is-disabled' : ''
                        }`
                      "
                    >
                      {{
                        neraKaina
                          ? '0.00 Eur'
                          : paslaugaAfterLabel(paslaugaItem)
                      }}
                    </div>
                  </div>
                </v-col>
                <v-col
                  v-if="isKodas && paslaugaIndex < paslaugaList.length - 1"
                  cols="12"
                  sm="12"
                >
                  <div class="paslauga-kodas py-2">arba</div>
                </v-col>
              </v-row>
            </v-col>
          </template>

          <component
            :is="paieskaComponent"
            :key="paiTipas"
            :main-data="mainData"
            :salys="salys"
            class="tabComponent"
            @turtasRusisText="turtasRusisText"
          ></component>

          <v-col cols="12" md="12" v-if="!isSelf">
            <el-textarea
              required
              :counter="1000"
              label="Duomenų naudojimo tikslas"
              tooltip="Paieška. Duomenų naudojimo tikslas"
              v-model="mainData.pai_duomenu_naudojimo_tikslas"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="mt-0 pt-0 mb-3"
            v-if="showBeFizinioKodo"
          >
            <el-checkbox
              class="mt-0 pt-0"
              label="Išrašas be fizinio asmens kodo"
              tooltip="Paieška. Kodas. Išrašas be fizinio asmens kodo"
              v-model="mainData.be_fizinio_kodo"
            />
          </v-col>
          <template v-if="isIsrasasNtr">
            <v-col cols="12" md="6" class="mb-3">
              <el-radio-group
                class="my-0"
                :items="ntrFADuomenys"
                v-model="mainData.ntr_fa_duomenys"
              />
            </v-col>
            <v-col cols="12" md="6" class="mb-3">
              <div>
                <el-checkbox
                  label="Su istoriniais duomenimis"
                  tooltip="Paieška. Turtas. NTR išrašas. Su istoriniais duomenimis"
                  :readonly="!showIstoriniaiDuomenys"
                  :label-grey="!showIstoriniaiDuomenys"
                  v-model="mainData.ntr_su_istorija"
                />
              </div>
              <div>
                <el-checkbox
                  label="Anglų kalba"
                  tooltip="Paieška. Turtas. NTR išrašas. Anglų kalba"
                  v-model="mainData.ntr_anglu_kalba"
                />
              </div>
            </v-col>
          </template>
          <template v-if="isSavitarna">
            <v-col cols="12" md="12" v-if="!isSelf">
              <el-textarea
                required
                :counter="1000"
                label="Teisinis pagrindas"
                tooltip="Paieška. Teisinis pagrindas"
                v-model="mainData.pai_teisinis_pagrindas"
              />
            </v-col>
            <v-col cols="12" md="12" v-if="!isSelf">
              <template v-if="!isByla">
                <div class="upload-label">
                  <div class="div-inline">
                    <label :class="uploadClass">
                      Pagrindžiantys dokumentai
                    </label>
                    <div class="div-tooltip">
                      <el-tooltip
                        :tooltip="`Paieška. Pagrindžiantys dokumentai`"
                      />
                    </div>
                  </div>
                  <div
                    v-if="uploadError"
                    class="v-messages theme--light error--text"
                    role="alert"
                  >
                    Laukas privalomas
                  </div>
                </div>

                <v-file-input
                  class="fileInput"
                  ref="fileInput"
                  :accept="fileType"
                  :multiple="multiple"
                  @change="addFiles"
                ></v-file-input>
                <v-card
                  ref="dragInput"
                  @drop.prevent="onDrop($event)"
                  @dragover.prevent="dragover = true"
                  @dragenter.prevent="dragover = true"
                  @dragleave.prevent="dragover = false"
                  @click.prevent="clickUpload"
                  :class="dragClass"
                  :disabled="!canUpload"
                >
                  <v-card-text>
                    <v-row
                      class="d-flex flex-column"
                      dense
                      align="center"
                      justify="center"
                    >
                      <v-icon
                        :class="[dragover ? 'mt-2, mb-6' : 'mt-5 ']"
                        color="primary"
                        size="60"
                      >
                        mdi-cloud-upload
                      </v-icon>
                      {{ uploadText }}
                    </v-row>
                    <v-list-item v-for="item in uploadedFiles" :key="item.name">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.name }}
                          <span class="ml-3 text--secondary">
                            {{ fileSize(item.size) }}</span
                          >
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action v-if="!instant" class="my-0">
                        <v-btn @click.stop="removeFile(item.name)" icon>
                          <v-icon> mdi-close-circle </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <div>
                      <v-progress-linear
                        :value="progress"
                        v-if="isUpload"
                        color="light-blue"
                        height="25"
                        disabled
                      >
                        <strong>{{ progress }} %</strong>
                      </v-progress-linear>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
              <template v-if="isByla">
                <v-card>
                  <v-card-text class="py-2">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ modalUpload.byl_pavadinimas }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn @click.stop="removeUploadedFile()" icon>
                          <v-icon> mdi-close-circle </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-card-text>
                </v-card>
              </template>
            </v-col>
          </template>
          <template v-if="isRoleArchyvas && false">
            <v-col cols="12" md="12">
              <p class="field-label text-inline">
                Dokumento (pagrindinio) įregistravimo laikotarpis
                <el-tooltip
                  tooltip="Paieška. Dokumento (pagrindinio) įregistravimo laikotarpis"
                />
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <el-date-picker
                label="nuo"
                tooltip="Paieška. Dokumento (pagrindinio) įregistravimo laikotarpis nuo"
                v-model="mainData.obj_iregistravimo_data_nuo"
              />
            </v-col>
            <v-col cols="12" md="6">
              <el-date-picker
                label="iki"
                tooltip="Paieška. Dokumento (pagrindinio) įregistravimo laikotarpis iki"
                v-model="mainData.obj_iregistravimo_data_iki"
              />
            </v-col>
          </template>
          <v-col cols="6" md="6" v-if="!isKodas && showKaina">
            <el-text-field
              readonly
              label="Kaina iš viso, Eur"
              v-model="paieskaFormKaina"
            />
          </v-col>
          <v-col cols="6" md="6" v-if="showAktualusIrasai">
            <el-checkbox
              class="mb-3 mt-0"
              label="Tik aktualūs įrašai"
              key="aktualus"
              v-model="mainData.aktualus_irasai"
            />
          </v-col>
          <template v-if="isRoleArchyvas">
            <v-col cols="12" md="12">
              <div class="archyvas-disclaimer">
                Archyviniai duomenys pateikiami nuo 2022 m. sausio 1 d.
                <br />Anksčiau išregistruotus objektus galite surasti Hipotekos
                registro archyve arba Sutarčių registro archyve.
              </div>
            </v-col>
          </template>
        </v-row>
      </form>
    </div>

    <paieska-confirm
      :title="confirmTitle"
      :text="confirmText"
      action="Paieska"
      v-model="showConfirm"
      :main-data="mainData"
      :tipas="paiTipas"
      :kaina="paieskaFormKaina"
      @confirmPaieska="searchData"
      @cancelConfirm="cancelPaieska"
    />

    <v-row class="mt-3">
      <v-col cols="12">
        <template v-if="!hideSubmit">
          <el-button
            :loading="loadingConfirm"
            primary
            @click.native.stop="startConfirm()"
          >
            {{ submitButton }}
          </el-button>
          <el-button :loading="loadingConfirm" @click.native="clearData()">
            Išvalyti
          </el-button>
        </template>
      </v-col>
    </v-row>

    <div ref="paieskaResult"></div>
    <template v-if="showResult">
      <paieska-result
        v-if="isKodas"
        :paieska-id="paieskaId"
        :loading="loadingResult"
      />
      <template v-if="!isKodas">
        <v-card class="my-4 py-2">
          <v-card-title class="mt-0 pt-1 pb-2">
            <h4>Vykdoma paieška</h4>
          </v-card-title>
          <v-card-text class="mb-0 pb-2">
            Jūsų užsakymas sėkmingai pateiktas VĮ Registrų centrui. Užsakymo
            būseną galite stebėti pasirinkę meniu punktą
            <el-button primary @click.native.stop="gotoPaieskaMano()"
              >Mano paieškos</el-button
            >
          </v-card-text>
        </v-card>
      </template>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import userRole from '../../mixins/userRole'
import paieskaNtrIsrasasTipai from './paieskaNtrIsrasasTipai'
import paieskaPaslaugaList from './paieskaPaslaugaList'
import PaieskaConfirm from './PaieskaConfirm'

import PaieskaJuridinis from './PaieskaJuridinis'
import PaieskaFizinis from './PaieskaFizinis'
import PaieskaTurtas from './PaieskaTurtas'
import PaieskaKodas from './PaieskaKodas'
import PaieskaResult from './PaieskaResult'

export default {
  name: 'PaieskaForm',
  components: {
    PaieskaJuridinis,
    PaieskaFizinis,
    PaieskaTurtas,
    PaieskaKodas,
    PaieskaResult,
    PaieskaConfirm,
  },
  mixins: [paieskaPaslaugaList, paieskaNtrIsrasasTipai, userRole, math],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    tipas: String,
    formTitle: String,
  },
  data() {
    return {
      mainData: {
        paslauga: null,
        hipoteka: false,
        sutartis: false,

        asm_asmens_kodas: null,
        asm_pavadinimas: null,
        asm_fiz_vardas: null,
        asm_fiz_pavarde: null,
        asm_gimimo_data: null,
        sasm_role_objekte: null,
        asm_kodo_tipas: null,
        foreign: null,
        self: false,

        tur_rusis: null,
        tur_identifikatorius: null,
        tur_orlaivis_registracijos_zenklas: null,
        tur_ktp_valstybinis_numeris: null,
        tur_ginklas_numeris: null,
        tur_juru_laivas_registracijos_numeris: null,
        tur_laivelis_registracijos_numeris: null,
        reg_nr: null,

        obj_identifikavimo_kodas: null,

        pai_duomenu_naudojimo_tikslas: null,
        pai_teisinis_pagrindas: null,

        obj_iregistravimo_data_nuo: null,
        obj_iregistravimo_data_iki: null,

        aktualus_irasai: true,

        ntr_fa_duomenys: null,
        ntr_su_istorija: false,
        ntr_anglu_kalba: false,
      },
      selectedPaslauga: [],
      paieskaItems: [],
      searching: false,
      showResult: false,
      pageloading: false,
      loadingResult: false,

      showConfirm: false,
      loadingConfirm: false,
      confirmTurtasRusis: null,
      confirmKlaida: null,

      paieskaId: null,
      salys: [],

      modalloading: true,
      modalUpload: {
        byl_rusis_kla_id: null,
        byl_dokumento_nr: null,
        byl_dokumento_data: null,
        byla: null,
      },
      dragover: false,
      progress: 0,
      uploadedFiles: [],
      fileType: '.pdf,.adoc,.asice',
      multiple: true,
      instant: false,
      uploadValidated: true,
      hideSubmit: false,
    }
  },
  computed: {
    ...mapGetters(['paieskaKaina', 'appSavitarna']),
    paieskaComponent() {
      if (this.isJuridinis) {
        return PaieskaJuridinis
      }
      if (this.isFizinis) {
        return PaieskaFizinis
      }
      if (this.isTurtas) {
        return PaieskaTurtas
      }
      if (this.isKodas) {
        return PaieskaKodas
      }
      return null
    },
    paiTipas() {
      return this.tipas
    },
    isJuridinis() {
      return this.paiTipas === 'juridinis'
    },
    isFizinis() {
      return this.paiTipas === 'fizinis'
    },
    isTurtas() {
      return this.paiTipas === 'turtas'
    },
    isIsrasasNtr() {
      return this.mainData.paslauga === 'israsas'
    },
    isKodas() {
      return this.paiTipas === 'kodas'
    },
    paieskaTitle() {
      return this.formTitle
    },
    compPaslauga() {
      return this.mainData.paslauga
    },
    isForeign() {
      return (this.mainData && this.mainData.foreign) ?? false
    },
    isSelf() {
      return (this.mainData && this.mainData.self) ?? false
    },
    neraKaina() {
      return this.isFizinis && this.isSelf
    },
    showKaina() {
      return !(
        this.roleRG ||
        this.role('KAC_darbuotojas') ||
        this.roleSkaitytojas
      )
    },
    showAktualusIrasai() {
      return (
        (this.selectedPaslauga.includes('sarasasSutartis') ||
          this.selectedPaslauga.includes('sarasasHipoteka')) &&
        !this.isSavitarna
      )
    },
    compForeign() {
      return this.mainData ? this.mainData.foreign : false
    },
    compTurtasRusis() {
      return this.mainData ? this.mainData.tur_rusis : false
    },
    isRoleSarasas() {
      if (this.isSavitarna) {
        return true
      }
      if (this.paiTipas === 'juridinis') {
        return this.role('P_S_pagal_JA')
      }
      if (this.paiTipas === 'fizinis') {
        return this.role('P_S_pagal_FA')
      }
      if (this.paiTipas === 'turtas') {
        return this.role('P_S_pagal_turta')
      }
      return true
    },
    isRolePatikra() {
      if (this.isSavitarna) {
        return true
      }
      if (this.paiTipas === 'juridinis') {
        return this.role('P_TZ_pagal_JA')
      }
      if (this.paiTipas === 'fizinis') {
        return this.role('P_TZ_pagal_FA')
      }
      if (this.paiTipas === 'turtas') {
        return this.role('P_TZ_pagal_turta')
      }
      return true
    },
    showTipasSutartis() {
      return !this.mainData.paslauga || this.mainData.paslauga === 'sarasas'
    },
    requiredHipoteka() {
      return !this.mainData.sutartis
    },
    requiredSutartis() {
      return !this.mainData.hipoteka
    },
    isRoleArchyvas() {
      return this.roleOr(['P_IA_pagal_ID', 'P_IAT_pagal_ID'])
    },
    isPatikra() {
      return this.mainData.paslauga == 'patikra' || this.isKodas
    },
    paieskaFormKaina() {
      let kaina = 0
      if (this.neraKaina) {
        return '0,00'
      }
      if (this.mainData.paslauga === 'sarasas') {
        kaina += this.mainData.hipoteka
          ? this.paieskaKaina.sarasas_hipoteka.kaina
          : 0
        kaina += this.mainData.sutartis
          ? this.paieskaKaina.sarasas_sutartis.kaina
          : 0
      }
      if (this.mainData.paslauga === 'patikra') {
        kaina += this.mainData.hipoteka
          ? this.paieskaKaina.patikra_hipoteka.kaina
          : 0
        kaina += this.mainData.sutartis
          ? this.paieskaKaina.patikra_sutartis.kaina
          : 0
      }
      if (this.mainData.paslauga === 'israsas') {
        kaina += this.paieskaKaina.israsas_ntr.kaina
      }
      if (this.mainData.paslauga === 'israsas_istorija') {
        kaina += this.mainData.hipoteka
          ? this.paieskaKaina.israsas_istorija_hipoteka.kaina
          : 0
        kaina += this.mainData.sutartis
          ? this.paieskaKaina.israsas_istorija_sutartis.kaina
          : 0
      }
      return this.moneyformat(kaina)
    },
    confirmTitle() {
      if (this.isKodas) {
        return 'Išrašo užsakymas'
      }
      return 'Paieškos užsakymas'
    },
    confirmText() {
      let text = 'Ar norite užsakyti paiešką pagal '
      if (this.isJuridinis) {
        text += '<b>juridinį asmenį</b>?'
      }
      if (this.isFizinis) {
        text += '<b>fizinį asmenį</b>?'
      }
      if (this.isTurtas) {
        text += '<b>' + (this.confirmTurtasRusis ?? 'turtą') + '</b>?'
      }
      if (this.isKodas) {
        text =
          'Ar norite užsakyti išrašą pagal identifikavimo kodą <b>' +
          this.mainData.obj_identifikavimo_kodas +
          '</b>?'
      }

      text += '<br />' + 'Kaina, Eur: ' + this.paieskaFormKaina
      return text
    },
    isSavitarna() {
      return this.appSavitarna
    },
    submitButton() {
      return this.isKodas ? 'Tęsti' : this.isSavitarna ? 'Užsakyti' : 'Ieškoti'
    },
    showConfirmKlaida() {
      return this.confirmKlaida
    },
    dragClass() {
      return (this.dragover ? 'blue lighten-1' : '') + 'mb-2'
    },
    isUpload() {
      return this.uploadedFiles.length > 0
    },
    uploadText() {
      return 'Paspauskite arba įtempkite rinkmeną'
    },
    bylosRusysList() {
      return this.bylosRusys.map(item => {
        return item
      })
    },
    isRusis() {
      return this.modalUpload.byl_rusis_kla_id &&
        this.modalUpload.byl_rusis_kla_id > 0
        ? true
        : false
    },
    canUpload() {
      return true
    },
    isByla() {
      return this.modalUpload.byl_id > 0 && this.modalUpload.byl_pavadinimas
    },
    isDeleted() {
      return (
        this.modalUpload.byl_id > 0 && this.modalUpload.byl_pavadinimas === null
      )
    },
    fileTypeList() {
      return this.fileType.replaceAll('.', '').split(',')
    },
    maxDydisByte() {
      return this.maxDydis * 1024 * 1024
    },
    uploadClass() {
      return `v-label theme--light ${
        this.uploadRequired ? 'required-text' : ''
      } ${this.uploadError ? 'error--text' : ''}`
    },
    uploadRequired() {
      return !this.selectedPaslauga.includes('patikraHipoteka')
        ? 'required'
        : ''
    },
    uploadError() {
      return !this.uploadValidated
    },
    showBeFizinioKodo() {
      return this.isKodas && this.role(['P_matyti_vard_pavard', 'P_matyti_AK'])
    },
  },
  watch: {
    compPaslauga(val) {
      this.mainData.paslauga = val
      if (val === 'patikra') {
        this.mainData.hipoteka = true
        this.mainData.sutartis = false
      }
      if (val === 'israsas') {
        this.mainData.hipoteka = false
        this.mainData.sutartis = false
      }
    },
    compForeign() {
      this.$validator.reset()
    },
    compTurtasRusis() {
      this.$validator.reset()
    },
    selectedPaslauga() {
      if (
        this.selectedPaslauga.includes('sarasasHipoteka') ||
        this.selectedPaslauga.includes('sarasasSutartis')
      ) {
        this.mainData.paslauga = 'sarasas'
      }
      this.mainData.hipoteka = this.selectedPaslauga.includes('sarasasHipoteka')
      this.mainData.sutartis = this.selectedPaslauga.includes('sarasasSutartis')

      if (this.selectedPaslauga.includes('patikraHipoteka')) {
        this.mainData.paslauga = 'patikra'
        this.mainData.hipoteka = true
        this.mainData.sutartis = false
      }
      if (this.selectedPaslauga.includes('israsasNtr')) {
        this.mainData.paslauga = 'israsas'
        this.mainData.hipoteka = false
        this.mainData.sutartis = false
        this.mainData.tur_rusis = 'ntr'
        if (this.mainData.ntr_fa_duomenys === null) {
          this.mainData.ntr_fa_duomenys = 'gimimo_data'
        }
      }
      if (this.selectedPaslauga.length === 0) {
        this.mainData.paslauga = null
        this.mainData.hipoteka = false
        this.mainData.sutartis = false
      }

      this.uploadValidated = true
      this.$validator.reset()
    },
    isSelf(val) {
      if (val) {
        this.mainData.pai_duomenu_naudojimo_tikslas = null
        this.mainData.pai_teisinis_pagrindas = null
        this.uploadedFiles = []
      }
    },
  },
  created() {
    if (this.isJuridinis) {
      this.getSalys()
    } else {
      this.pageloading = false
    }
  },
  methods: {
    getSalys() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`paieska/salys/list`)
        .then(res => {
          this.salys = res.data.salys
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    submit() {
      this.startConfirm()
    },
    turtasRusisText(text) {
      this.confirmTurtasRusis = text
    },
    startConfirm() {
      this.showResult = false
      this.paieskaId = null
      this.confirmKlaida = null

      this.validateUpload()
      this.$validator.validateAll().then(res => {
        if (res && this.uploadValidated) {
          this.loadingConfirm = true

          let searchData = this.getFormData()
          this.$axios
            .post(`paieska/tikrinti`, searchData)
            .then(res => {
              this.showConfirm = true
            })
            .catch(err => {
              this.confirmKlaida = err.response.data.message
              this.loadingConfirm = false
              this.$vuetify.goTo(this.$refs.topPaieskaForm)
            })
        } else {
          window._VMA.$emit('DATA_ERROR', 'Užpildykite privalomus laukus')
        }
      })
    },
    cancelPaieska() {
      this.loadingConfirm = false
    },
    getFormData() {
      let searchData = new FormData()

      let paiTipas = this.paiTipas
      let paslauga = this.mainData.paslauga
      if (this.isTurtas && this.isIsrasasNtr) {
        paiTipas = 'israsas_ntr'
        paslauga = 'sarasas'
      }
      searchData.append('pai_tipas', paiTipas)
      searchData.append('paslauga', paslauga)

      if (!this.showAktualusIrasai) {
        this.mainData.aktualus_irasai = false
      }

      Object.entries(this.mainData).forEach(([key, value]) => {
        if (key === 'paslauga') {
          return
        }
        if (value !== null) {
          if (value === true) {
            value = 1
          }
          if (value === false) {
            value = 0
          }
          searchData.append(key, value)
        }
      })

      if (this.isUpload) {
        this.uploadedFiles.forEach((byla, index) => {
          searchData.append(`byla[${index}]`, byla)
        })
      }

      return searchData
    },
    searchData() {
      let searchData = this.getFormData()

      const config = {
        onUploadProgress: progressEvent => {
          this.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
        },
      }

      this.$axios
        .post(`paieska/paieska`, searchData, config)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.paieskaId = res.data.paieska.pai_id
          this.showResult = true
          if (this.isSavitarna) {
            this.hideSubmit = true
          }
          this.$vuetify.goTo(this.$refs.paieskaResult)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadingConfirm = false
        })
    },
    clearData() {
      this.selectedPaslauga = []
      this.mainData = {
        paslauga: null,
        hipoteka: false,
        sutartis: false,

        asm_asmens_kodas: null,
        asm_pavadinimas: null,
        asm_fiz_vardas: null,
        asm_fiz_pavarde: null,
        asm_gimimo_data: null,
        sasm_role_objekte: null,
        asm_kodo_tipas: null,
        foreign: null,
        self: false,

        tur_rusis: null,
        tur_identifikatorius: null,
        tur_orlaivis_registracijos_zenklas: null,
        tur_ktp_valstybinis_numeris: null,
        tur_ginklas_numeris: null,
        tur_juru_laivas_registracijos_numeris: null,
        tur_laivelis_registracijos_numeris: null,
        reg_nr: null,

        obj_identifikavimo_kodas: null,

        pai_duomenu_naudojimo_tikslas: null,

        obj_iregistravimo_data_nuo: null,
        obj_iregistravimo_data_iki: null,

        aktualus_irasai: true,
      }
      this.modalUpload = {
        byl_rusis_kla_id: null,
        byl_dokumento_nr: null,
        byl_dokumento_data: null,
        byla: null,
      }
      this.uploadedFiles = []
      this.showResult = false
      this.paieskaId = null
      this.confirmKlaida = null
      this.uploadValidated = true
      this.$validator.reset()
    },
    gotoPaieskaMano() {
      this.$router.push({
        name: this.isSavitarna ? 'savPaieskaMano' : 'paieskaMano',
      })
    },
    paslaugaAfterLabel(paslaugaItem) {
      return `${this.moneyformat(paslaugaItem.kaina)} Eur`
    },
    clickUpload() {
      this.$refs.dragInput.$el.blur()
      this.$refs.fileInput.$refs.input.click()
    },
    addFiles(files) {
      this.dragover = false
      // files.forEach(element => this.addUploadedFiles(element))
      let fileArray
      if (Array.isArray(files)) {
        fileArray = [...files]
      } else {
        fileArray = [files]
      }
      fileArray.forEach(element => this.addUploadedFiles(element))

      if (this.instant) {
        this.saveData()
      }
    },
    addUploadedFiles(element) {
      let tipas = element.name
        .toLowerCase()
        .split('.')
        .pop()
      if (!this.fileTypeList.includes(tipas)) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Netinkamas dokumento formatas, galima įkelti tik PDF, ADOC ir ASICE'
        )
        return
      }
      if (element.size > this.maxDydisByte) {
        window._VMA.$emit(
          'DATA_ERROR',
          `Leistinas dokumento dydis: ${this.maxDydis} MB`
        )
        return
      }
      this.uploadedFiles.push(element)
      this.validateUpload()
    },
    fileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return Math.round(size / 1024) + ' KB'
      } else if (size < 1024 * 1024 * 1024) {
        return Math.round(size / (1024 * 1024)) + ' MB'
      }
    },

    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(file => file.name === fileName)

      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1)
    },
    removeUploadedFile() {
      this.modalUpload.byl_pavadinimas = null
    },

    onDrop(e) {
      this.dragover = false

      // If there are already uploaded files remove them
      if (this.isUpload && !this.multiple) this.uploadedFiles = []

      // If user has uploaded multiple files but the component is not multiple throw error
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Vienu metu galima įkelti tik vieną doumentą'
        )
      }
      // Add each file to the array of uploaded files
      else {
        //e.dataTransfer.files.forEach(element => this.addUploadedFiles(element))
        const fileArray = [...e.dataTransfer.files]
        fileArray.forEach(element => this.addUploadedFiles(element))
      }

      if (this.instant) {
        this.saveData()
      }
    },
    updateProgress(progress) {
      this.progress = progress
    },
    validateUpload() {
      this.uploadValidated =
        this.isUpload ||
        !this.uploadRequired ||
        !this.isSavitarna ||
        this.mainData.self
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
.fileInput {
  display: none;
}
.div-inline {
  display: inline-flex;
  line-height: 20px;
}
.div-tooltip {
  font-size: 14px;
}
.upload-label label {
  font-size: 1.12em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
}
.paslauga-kodas {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.archyvas-disclaimer {
  font-size: 0.85rem;
}
</style>
